import { toast } from 'sonner';
import './ResetColumnsButton.css';

interface ResetColumnsButtonProps {
  disabled?: boolean;
  onReset: () => void;
}

export function ResetColumnsButton({ disabled = false, onReset }: ResetColumnsButtonProps) {
  const handleClick = () => {
    onReset();
    toast.success('Columns reset to defaults.');
  };

  return (
    <button
      type="button"
      className="sky-grid-reset-button"
      aria-label="Reset columns to defaults"
      title="Restore default columns, order, visibility, widths, pinning, and sorting"
      disabled={disabled}
      onClick={handleClick}
    >
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
        <path d="M3 12a9 9 0 1 0 3-6.7" />
        <path d="M3 4v6h6" />
      </svg>
      Reset columns
    </button>
  );
}
